import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {AttachmentBasePublicProps} from '../../../../../../libs/shared/ui/src/components/attachments/attachmentBasePublicProps';
import {AttachmentBaseContainer} from './attachmentBaseContainer';

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  &:not(:first-child) {
    border-top: 1px solid ${(p) => p.theme.greys.shade40};
  }
`;

interface AttachmentBaseContainerStyleProps {
  $isInteractionDisabled?: boolean;
  $newMultiAttachmentStyle?: boolean;
}

export const StyledAttachmentBase = styled(AttachmentBaseContainer)<AttachmentBaseContainerStyleProps>`
  box-sizing: unset;

  ${(p) =>
    p.$newMultiAttachmentStyle &&
    css`
      background-color: ${p.theme.foreground};
      border: 1px solid ${p.theme.alphas.black40};

      &:hover {
        background-color: ${p.theme.greys.shade20};
      }
    `}

  ${(p) =>
    !p.$newMultiAttachmentStyle &&
    !p.$isInteractionDisabled &&
    css`
      &:hover {
        background-color: ${p.theme.greys.shade40};
      }
    `}
`;

/*
 * Component.
 */

export const CommentAttachment: FC<AttachmentBasePublicProps> = (props) => {
  if (props.newMultiAttachmentStyle) {
    return (
      <StyledAttachmentBase
        {...props}
        $newMultiAttachmentStyle={props.newMultiAttachmentStyle}
        $isInteractionDisabled={props.isInteractionDisabled}
      />
    );
  }

  return (
    <StyledWrapperDiv>
      <StyledAttachmentBase
        {...props}
        $newMultiAttachmentStyle={props.newMultiAttachmentStyle}
        $isInteractionDisabled={props.isInteractionDisabled}
      />
    </StyledWrapperDiv>
  );
};
